<template lang="">
    <div class="current-plan" @click="showPlans(type, 'change-plan')">
        <div class="current-plan-head">
            <div class="current-plan-title">
                {{
                    type
                        .split("-")
                        .map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase())
                        .join(" ")
                }}
            </div>
            <div v-if="buttonAction" style="display: grid; grid-template-columns: auto auto; column-gap: 4px">
                <div class="current-plan-status" v-if="planAction">Paketi Yönetimi</div>
                <div class="current-plan-status" v-else>Satın Al</div>
            </div>
            <div v-else-if="planAction" class="current-plan-status">Mevcut Plan</div>
        </div>
        <div class="current-plan-body">
            <div class="current-plan-details">
                <div class="plan-detail">
                    <div>Paket Türü</div>
                    <div>
                        {{ (planAction && plan && plan.altTitle) || "N/A" }}
                    </div>
                </div>
                <div class="plan-detail">
                    <div>Paket Dönemi</div>
                    <div>
                        {{ (planAction && planAction.plan.period) || "N/A" }}
                    </div>
                </div>
                <div class="plan-detail" v-if="type == 'supsis'">
                    <div>Temsilci Sayısı</div>
                    <div>
                        {{
                            ((planAction && planAction.plan.details && planAction.plan.details.agentCount) || 1) +
                            getFreeAgentCredit()
                        }}
                        ({{ getFreeAgentCredit() }}
                        Ücretsiz)
                    </div>
                </div>
                <div class="plan-detail" v-if="type == 'whatsapp' || type == 'whatsapp-business'">
                    <div>Kanal Sayısı</div>
                    <div>
                        {{
                            (planAction && planAction.plan.details && planAction.plan.details.whatsappChannel) || "N/A"
                        }}
                    </div>
                </div>
                <div class="plan-detail" v-if="!detailPackage().enabled">
                    <div>Kalan Süre</div>
                    <div>N/A</div>
                </div>
                <div class="plan-detail" v-else-if="!detailPackage().renewed">
                    <div>Kalan Süre</div>
                    <div>{{ detailPackage().leftTime }} gün</div>
                </div>
                <div
                    class="plan-detail"
                    v-if="detailPackage().renewed"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                    }"
                    :content="'Yenileme Tarihi'"
                >
                    <div>Yenileme T.</div>
                    <div>{{ detailPackage().endDate }}</div>
                </div>
            </div>
            <div class="image">
                <DynamicSvg :name="getIcon(type)" />
            </div>
        </div>
    </div>
</template>
<script>
import DynamicSvg from "../DynamicSvg.vue";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "CurrentPlanCard",
    components: {
        DynamicSvg,
    },
    props: {
        type: {
            type: String,
            default: null,
        },
        planAction: {
            default: null,
        },
        plan: {
            default: null,
        },
        buttonAction: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        icons: {
            whatsapp: "CWhatsapp",
            "whatsapp-business": "CWhatsappBusiness",
            supsis: "CSupsis",
            chatbot: "CChatbot",
            instagram: "CInstagram",
            telegram: "CSupsis",
            custom: "CSupsis",
        },
    }),
    computed: {
        ...mapState({
            currentPlans: (state) => state.site.currentPlans,
            plans: (state) =>
                state.site.plans.reduce((acc, plan) => {
                    acc[plan._id] = plan;
                    return acc;
                }, {}),
        }),
    },
    methods: {
        formatTitle() {},
        showPlans(planType, type) {
            this.$emit("show-plans", planType);
        },
        getIcon(type) {
            return this.icons[type] || "CSupsis";
        },
        detailPackage() {
            let detail = {
                enabled: false,
                renewed: false,
                leftTime: 0,
                endDate: null,
            };
            if (this.planAction) {
                const isYearly = this.planAction.plan.period == "annual";
                const startDate = moment(this.planAction.plan.createdDate);
                detail.leftTime = moment(this.planAction.plan.endDate).diff(startDate, "days");
                if (this.planAction.plan.enabled || !this.planAction.plan.endDate) {
                    detail.renewed = true;
                    detail.endDate = moment()
                        .add(1, isYearly ? "year" : "month")
                        .startOf(isYearly ? "year" : "month")
                        .format("YYYY/MM/DD");
                }
                detail.enabled = true;
            }
            return detail;
        },
        getFreeAgentCredit() {
            const features = Object.keys(this.currentPlans).reduce((acc, type) => {
                const plan = this.plans[this.currentPlans[type]?.plan?.planId];
                if (plan) acc.push(...plan.features);
                return acc;
            }, []);
            const agentFeatures = features.filter((feature) => feature.type == "agent");
            const freeAgentCount = agentFeatures.reduce((acc, feature) => acc + (+feature.freeAgentCount || 0), 0);
            return freeAgentCount;
        },
    },
};
</script>
<style lang="scss">
.current-plan {
    background: white;
    padding: 20px;
    border-radius: 15px;
    cursor: pointer;

    .current-plan-head {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .current-plan-title {
            font-size: 18px;
            font-weight: bold;
            color: black;
        }

        .current-plan-status {
            background: rgb(236, 75, 29);
            padding: 3px 10px;
            border-radius: 5px;
            color: white;
            cursor: pointer;
        }
    }

    .current-plan-body {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .current-plan-details {
            margin-right: 30px;

            .plan-detail {
                display: flex;
                align-items: center;

                :nth-child(1) {
                    width: 100px;
                }

                :nth-child(2) {
                    font-weight: bold;
                }
            }
        }

        .image {
            width: 80px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
        }
    }
}
</style>
